export const roomActions={
    OPEN_ROOM:"ROOM.OPEN_ROOM",
    SET_ROOM_DETAILS:"ROOM.SET_ROOM_DETAILS",
    SET_ACTIVE_ROOMS:"ROOM.SET_ACTIVE_ROOMS",
    SET_LOCAL_STREAM:"ROOM.SET_LOCAL_STREAM",
    SET_REMOTE_STREAMS:"ROOM.SET_REMOTE_STREAMS",
    SET_AUDIO_ONLY:"SET_AUDIO_ONLY",
    SET_SCREEN_SHARE_STREAM:"ROOM.SET_SCREEN_SHARE_STREAM",
    SET_SERVERS:"ROOM.SET_SERVERS",
    ADD_SERVER:"ROOM.ADD_SERVER",
    SET_SELECTED_SERVER:"ROOM.SET_SELECTED_SERVER",
    SET_SELECTED_CHANNEL:"ROOM.SET_SELECTED_CHANNEL",
    SET_VOICE_PARTICIPANTS:"ROOM.SET_VOICE_PARTICIPANTS",
    SET_SERVER_INVITATIONS:"ROOM.SET_SERVER_INVITATIONS",
    REMOVE_SERVER_INVITATION:"ROOM.REMOVE_SERVER_INVITATION",
    UPDATE_SERVER:"ROOM.UPDATE_SERVER",

};
export const setOpenRoom=(isUserRoomCreator=false,isUserInRoom=false)=>{
return {
    type:roomActions.OPEN_ROOM,
    isUserRoomCreator:isUserRoomCreator,
    isUserInRoom,
}
}

export const setServers = (servers) => ({
    type: roomActions.SET_SERVERS,
    servers,
});

export const addServer = (server) => ({
    type: roomActions.ADD_SERVER,
    server,
});

export const setSelectedServer = (server) => ({
    type: roomActions.SET_SELECTED_SERVER,
    server,
});

export const setSelectedChannel = (channel) => ({
    type: roomActions.SET_SELECTED_CHANNEL,
    channel,
});

export const setVoiceParticipants = (participants, roomId = null) => ({
    type: roomActions.SET_VOICE_PARTICIPANTS,
    participants,
    roomId,
});

export const setServerInvitations = (invitations) => ({
    type: roomActions.SET_SERVER_INVITATIONS,
    invitations,
});

export const removeServerInvitation = (invitationId) => ({
    type: roomActions.REMOVE_SERVER_INVITATION,
    invitationId,
});

export const updateServer = (server) => ({
    type: roomActions.UPDATE_SERVER,
    server,
});
